<template>
    <v-container app :fluid="true" class="pt-0 pb-0">
        <v-row>
            <v-col cols="6">
                <v-text-field
                    v-model="search"
                    append-icon="fas fa-search"
                    label="Buscar rol"
                    solo
                    dense
                    hide-details
                    class="wost-text-input"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-btn 
                    @click="$refs.createOrUpdate.showForm('Nuevo rol de usuario', 'create')" 
                    rised 
                    color="indigo" 
                    dark
                    class="float-right wost-btn-new"
                    v-if="verifyPermission('crear_roles')">
                    <v-icon dark left size="12">fas fa-plus</v-icon>Nuevo rol
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="roles"
                        item-key="name"
                        :search="search"
                        :disable-pagination="true"
                        height="68vh"
                        fixed-header
                        v-if="verifyPermission('listar_roles')"
                    >
                        <template v-slot:item.action="{ item }">
                            <div class="datatable-cell-wrapper">
                                <a href="#" title="Editar" 
                                    class="btn-actions btn-edit" 
                                    @click="editRole(item)"
                                    v-if="verifyPermission('actualizar_roles')">
                                    <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                                </a>
                                &nbsp;
                                <a v-if="item.status  === 'activo' && verifyPermission('inactivar_roles')" 
                                    href="#" 
                                    title="Inactivar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'inactivar')">
                                    <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                                </a>
                                <a v-else-if="item.status  === 'inactivo' && verifyPermission('activar_roles')"
                                    href="#" 
                                    title="Activar" 
                                    class="btn-actions btn-delete" 
                                    @click="changeStatus(item, 'activar')">
                                    <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                                </a>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <create-or-update ref="createOrUpdate" />
    </v-container>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import CreateOrUpdate from '../components/Roles/CreateOrUpdate.vue'
import {APIService} from '@/APIService';

const apiService = new APIService();

export default {
    name: 'Roles',
    components: {
        CreateOrUpdate
    },
    data() {
        return {
            search: '',
            headers: [
                { text: 'Nombre', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Descripción', value: 'description', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 }
            ],
        }
    },
    computed: {
        ...mapState('roles', [
            'roles',
        ]),
    },
    methods: {
        ...mapActions('roles', [
            'getRoles',
            'viewForm',
            'inactivateRole',
            'getAvailablePermits'
        ]),
        ...mapMutations('roles', [
            'setRole',
            'setRoleId'
        ]),
        editRole(role){            
            let roleEdit = this.createRoleEdit(role)            
            this.setRole(roleEdit)
            this.$refs.createOrUpdate.showForm('Modificar datos de rol', 'update')
            console.log(roleEdit)
        },
        createRoleEdit(role) {
            let permissionsIds = this.getPermissionsId(role.permissions)

            let roleEdit = {
                id: role.id,
                slug: role.slug,
                name: role.name,
                description: role.description,
                selected: permissionsIds
            }

            return roleEdit
        },
        getPermissionsId(permissions){
            let permissionsIds = []
            for(let i = 0; i < permissions.length; i++) {
                permissionsIds.push(permissions[i].id)
            }

            return permissionsIds
        },
        changeStatus(item, status) {
            this.setRoleId(item.id)
            this.$swal({
                    title: "¿Desea confirmar?",
                    text: "Confirma que desea " + status + " el rol de usuario",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if(result.value){
                        if(result.value === true){
                            this.inactivateRole()
                        }
                    }                    
                })
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getRoles()
        this.getAvailablePermits()
    }
}
</script>

<style>

</style>